export const TOKEN_COOKIE_KEY = 'ent-token'
export const MANUAL_PROFILE = 'Manual.Profile'

// product types for options order tracking, mirrors PLS
export const CREDIT_CARD_PRODUCT_TYPE = 'PRODUCT_TYPE_CREDIT_CARD'
export const LOAN_PRODUCT_TYPE = 'PRODUCT_TYPE_LOAN'
